"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var withTheme_1 = require("../utils/withTheme");

var isMouseDown = function isMouseDown(e) {
  return e.type === 'mousedown';
};

var Slider =
/** @class */
function (_super) {
  __extends(Slider, _super);

  function Slider(props) {
    var _this = _super.call(this, props) || this;

    _this.handleMouseLeave = function () {
      _this.setState({
        hover: null
      });
    };

    _this.handleMouseMove = function (e) {
      if (e.target.nodeName.toLowerCase() === 'button') {
        return _this.setState({
          hover: null
        });
      }

      _this.setState({
        hover: _this.getDragPosition(e.clientX, e.clientY)
      });
    };

    _this.handleClick = function (e) {
      e.preventDefault();

      if (e.target.nodeName.toLowerCase() === 'button') {
        return;
      }

      if (_this.props.onValueChange) {
        var value = _this.getDragPosition(e.clientX, e.clientY);

        _this.props.onValueChange(value);
      }
    };

    _this.handleDragStart = function (e) {
      // Handle only left click.
      if (isMouseDown(e) && e.buttons !== 1) {
        return;
      }

      e.preventDefault();

      _this.createDragContext(isMouseDown(e) ? 'mouse' : 'touch');

      _this.handleDragging(e.nativeEvent);
    };

    _this.handleDragging = function (e) {
      e.preventDefault();

      if (!_this.elementRef) {
        return;
      }

      var clientX;
      var clientY;

      if (e instanceof MouseEvent) {
        clientX = e.clientX;
        clientY = e.clientY;
      } else {
        var touch = e.touches.item(0);

        if (!touch) {
          return;
        }

        clientX = touch.clientX;
        clientY = touch.clientY;
      }

      _this.setState({
        drag: _this.getDragPosition(clientX, clientY)
      });
    };

    _this.handleStopDragging = function (e) {
      e.preventDefault();

      _this.removeDragContext();

      if (_this.props.onValueChange && _this.state.drag !== null) {
        _this.props.onValueChange(_this.state.drag);
      }

      setTimeout(function () {
        _this.setState({
          drag: null
        });
      }, 200);
    };

    _this.dragContext = null;
    _this.elementRef = null;
    _this.state = {
      hover: null,
      drag: null
    };
    return _this;
  }

  Slider.prototype.getDragPosition = function (clientX, clientY) {
    if (!this.elementRef) {
      return 0;
    }

    var _a = this.props,
        max = _a.max,
        orientation = _a.orientation;
    var bounds = this.elementRef.getBoundingClientRect();
    var fraction = orientation === 'vertical' ? 1 - (clientY - bounds.top) / bounds.height : (clientX - bounds.left) / bounds.width;
    return Math.min(Math.max(fraction, 0), 1) * max;
  };

  Slider.prototype.createDragContext = function (pointerType) {
    var dragContext = {
      moveHandler: this.handleDragging,
      stopHandler: this.handleStopDragging
    };

    if (pointerType === 'mouse') {
      document.addEventListener('mousemove', dragContext.moveHandler);
      document.addEventListener('mouseup', dragContext.stopHandler);
    } else {
      document.addEventListener('touchmove', dragContext.moveHandler);
      document.addEventListener('touchend', dragContext.stopHandler);
    }

    this.dragContext = dragContext;
  };

  Slider.prototype.removeDragContext = function () {
    if (!this.dragContext) {
      return;
    }

    document.removeEventListener('mousemove', this.dragContext.moveHandler);
    document.removeEventListener('mouseup', this.dragContext.stopHandler);
    document.removeEventListener('touchmove', this.dragContext.moveHandler);
    document.removeEventListener('touchend', this.dragContext.stopHandler);
    this.dragContext = null;
  };

  Slider.prototype.render = function () {
    var _this = this;

    var theme = this.context.theme;
    var _a = this.props,
        value = _a.value,
        max = _a.max,
        className = _a.className,
        orientation = _a.orientation,
        ariaLabel = _a.ariaLabel,
        ariaValueText = _a.ariaValueText,
        dimmed = _a.dimmed,
        onFocus = _a.onFocus,
        onBlur = _a.onBlur,
        onKeyUp = _a.onKeyUp,
        badge = _a.badge,
        hoverBadge = _a.hoverBadge;
    var _b = this.state,
        hover = _b.hover,
        drag = _b.drag;
    var classes = {
      slider: true,
      'slider--vertical': orientation === 'vertical',
      'slider--horizontal': orientation !== 'vertical',
      'slider--hover': Boolean(hover),
      'slider--hover-backward': Boolean(!drag && hover && hover < value),
      'slider--dragging': drag !== null,
      'slider--dimmed': Boolean(dimmed)
    };
    var currentPercentage = Math.min(value / max * 100, 100);
    var hoverPercentage = hover ? Math.min(hover / max * 100, 100) : 0;
    var dragPercentage = drag !== null ? Math.min(drag / max * 100, 100) : null;
    var positionPercentage = dragPercentage === null ? currentPercentage : dragPercentage || 0;
    var tickOffset = (1 - positionPercentage / 50) * 4;
    var ariaValues = {
      'aria-valuemin': 0,
      'aria-valuemax': max,
      'aria-valuenow': value,
      'aria-label': ariaLabel,
      'aria-valuetext': ariaValueText || value.toPrecision(1) + " av " + max,
      'aria-orientation': orientation
    };
    var hoverBarStyle = {
      width: '0%',
      left: '0%'
    };

    if (hover && !drag) {
      hoverBarStyle.width = hover >= value ? hoverPercentage - currentPercentage + "%" : hoverPercentage + "%";
      hoverBarStyle.left = hover >= value ? currentPercentage + "%" : '0%';
    }

    return withTheme_1.withTheme(theme, classes)(React.createElement("div", __assign({
      onMouseDown: this.handleDragStart,
      onMouseMove: this.handleMouseMove,
      onMouseLeave: this.handleMouseLeave,
      onTouchStart: this.handleDragStart,
      onKeyUp: onKeyUp,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: this.handleClick,
      role: "slider",
      className: className,
      draggable: true,
      tabIndex: 0,
      ref: function ref(_ref) {
        return _this.elementRef = _ref;
      }
    }, ariaValues), withTheme_1.withTheme(theme, 'slider__progress-bar')(React.createElement("div", {
      "aria-hidden": "true"
    }, withTheme_1.withTheme(theme, 'slider__progress-bar__total')(React.createElement("div", null)), withTheme_1.withTheme(theme, 'slider__progress-bar__progress')(React.createElement("div", {
      style: {
        width: positionPercentage + "%"
      }
    })), withTheme_1.withTheme(theme, 'slider__hover-bar')(React.createElement("div", {
      style: hoverBarStyle
    })))), withTheme_1.withTheme(theme, 'slider__tick')(React.createElement("div", {
      "aria-hidden": "true",
      style: {
        left: "calc(" + positionPercentage + "% + (" + tickOffset + "px))"
      }
    })), badge ? badge(positionPercentage) : null, hover && hoverBadge ? hoverBadge(hoverPercentage, hover) : null));
  };
  /**
   * Exposed for test
   */


  Slider.prototype.__getDragContext__ = function () {
    return this.dragContext;
  };

  Slider.contextTypes = {
    theme: PropTypes.object
  };
  return Slider;
}(React.Component);

exports["default"] = Slider;